<template>
  <div class="card-content columns is-marginless is-vcentered
    has-background-table-second-color">
    <div class="column is-3">
      <div class="columns
            is-paddingless is-marginless is-multiline is-vcentered">
        <div class="column is-2 is-paddingless">
          <qd-checkbox :disabled="!afficherLien" v-model="ligne.selectedLogistique"
                      class="mgr-20px" >
          </qd-checkbox>
        </div>
        <div class="column is-10">
          <div class="columns is-multiline">
                <span class="has-text-weight-bold has-text-link column
                  is-12 is-paddingless ellipsis">
                  <b-tooltip type="is-warning"
                             :label="$t('editionCommande.logistique.info.isAffecteLogistiquement')"
                             class="is-size-5"
                             v-if="ligne.isAffecteLogistiquement"
                             position="is-right"
                             append-to-body>
                    {{ ligne.produit.reference }}
                    <b-icon icon="alert" size="is-small" type="is-warning"></b-icon>
                  </b-tooltip>
                  <span v-else class="ellipsis is-size-5">
                    {{ ligne.produit.reference }}
                  </span>
                </span>
            <span class="has-text-default column is-12 is-paddingless ellipsis-two-line">
                {{ ligne.libelle }}
                </span>
            <span class="has-text-default column is-12 is-paddingless"
                  v-if="ligne.dateDebut && ligne.dateFin">
                <span v-if="ligne.ligneReseau && ligne.ligneReseau.anneeSemaine">
                  <label class="has-text-weight-bold">
                    {{ getPeriodeVendue(ligne).semaine }}
                  </label>
                  {{$t('detail.article.du')}}
                </span>
                <span v-else>{{$t('detail.article.duMaj')}}</span>

                <label class="has-text-weight-bold">
                  {{ getPeriodeVendue(ligne).dateDebut }}
                </label>
                {{$t('detail.article.au')}}
                <label class="has-text-weight-bold">
                  {{ getPeriodeVendue(ligne).dateFin }}
                </label>
            </span>
            <span class="has-text-default column is-12 is-paddingless" v-else>
                    {{ getPeriodeVendue(ligne) }}
                </span>
            <div class="has-text-default column is-12 is-paddingless">
              <div v-if="ligne.typeProduit === constantes.CATEGORIE_UNITAIRE">
                <b-tooltip type="is-warning"
                           :label="$t('editionCommande.logistique' +
                                '.info.dateAffichageDiffDatePlanifie')"
                           v-if="checkDateDateDebutDatePlanifiie"
                           position="is-right">
                  {{ $t('editionCommande.logistique.posePlanification') }}
                  <label class="has-text-weight-bold">
                    {{formatDate(ligne.datePlanifieeLogistiqueAffichage) }}
                  </label>
                  <b-icon icon="alert" size="is-small" type="is-warning"></b-icon>
                </b-tooltip>
                <div v-else>
                  {{ $t('editionCommande.logistique.posePlanification') }}
                  <label class="has-text-weight-bold">
                    {{ formatDate(ligne.datePlanifieeLogistiqueAffichage) }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="isDevis ? 'borderLeftOnly is-9 ' : 'borderLeftRight is-6'"
      class="column is-marginless min-height-100">
      <div
        v-if="ligne.typeProduit !== constantes.CATEGORIE_DIVERS &&
        ligne.typeProduit !== constantes.CATEGORIE_DISPOSITIF"
        class="columns is-vcentered is-paddingless is-marginless is-multiline">
        <div class="column is-6">
          <b-field :label="$t('editionCommande.logistique.instructionPose')">
            <b-input type="textarea" :disabled="readOnly"
                     v-model="ligne.instructionPose" :rows="2">
            </b-input>
          </b-field>
          <b-field :label="$t('editionCommande.logistique.dateLivraison')"
                   class='pdt-5'
                   v-if='ligne.typeProduit === constantes.CATEGORIE_REGROUPEMENT' >
            <b-datepicker show-week-number
                          v-model="ligne.dateLivraison"
                          icon="calendar-today"
                          position= 'is-bottom-left'
                          nearby-selectable-month-days
                          editable
                          :disabled="readOnly">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-6 is-vcentered">
          <div class="columns is-paddingless is-marginless is-multiline"
               v-if='ligne.typeProduit === constantes.CATEGORIE_REGROUPEMENT'>
            <b-field class= "column is-12 mgb-0">
              <qd-checkbox v-model="ligne.afficheLivre" :disabled="readOnly">
                <p class="label">
                  {{$t('editionCommande.logistique.affichesLivrees')}}
                </p>
              </qd-checkbox>
            </b-field>
            <b-field class="column is-12 pdt-0 mgb-0">
              <qd-checkbox v-model="ligne.nePasReafficher"
                          :disabled="readOnly">
                <p class="label">
                  {{$t('editionCommande.logistique.nePasReafficher')}}
                </p>
              </qd-checkbox>
            </b-field>
            <b-field class="column is-12 pdt-0 mgb-0">
              <qd-checkbox v-model="ligne.logistiqueVerrouillee"
                          :disabled="readOnly">
                <p class="label">
                  {{$t('editionCommande.logistique.logistiqueVerrouillee')}}
                </p>
              </qd-checkbox>
            </b-field>
          </div>
          <div v-else class="columns is-paddingless is-marginless is-vcentered is-multiline">
            <b-field class="column is-12 mgb-0">
              <qd-checkbox v-model="ligne.nePasReafficher"
                          :disabled="readOnly">
                <p class="label">
                  {{$t('editionCommande.logistique.nePasReafficher')}}
                </p>
              </qd-checkbox>
            </b-field>
            <b-field class="column is-12 pdt-0 is-vcentered" >
              <qd-checkbox v-model="ligne.aIntegrerDansLaLogistique"
                          :disabled="readOnly">
                <p class="label">
                  {{$t('editionCommande.logistique.aIntegrerDansLaLogistique')}}
                </p>
              </qd-checkbox>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-3" v-if="!isDevis">
      <div class="columns is-multiline is-paddingless is-marginless
        is-vcentered">
        <div class="column is-12" v-if="isIdByDefaut && !!ligne.id">
          <div class="columns is-multiline">
            <div class="column is-9 pdt-0">
              <p class="label">
                {{$t('editionCommande.logistique.demandeIntervention')}}
              </p>
            </div>
            <div class="column is-1 pdt-0">
              <b-tooltip :label="$t('demandeLogistique.tooltip.addDemande')"
                position="is-left">
                <a
                  @click="checkPermissions(permDemande.maj)
                    ? popUpAddDemandeLogistique = true : showPopUp()"
                  :class="{'disabled': !afficherLien}">
                  <b-icon icon="plus-circle"
                    type="is-primary"
                    :class="{ 'text-access-no-permission' : !checkPermissions(permDemande.maj) }">
                  </b-icon>
                </a>
              </b-tooltip>
            </div>
            <div class="column is-1 pdt-0">
              <b-tooltip :label="$t('demandeLogistique.tooltip.displayDemandes',
                  {nb: ligne.demandesLogistique.length})"
                position="is-left">
                <a @click="checkPermissions(permDemande.lecture)
                    ? popUpDisplayDemandeLogistique = true : showPopUp()"
                  :class="{'disabled': !afficherLien}">
                  <b-icon icon="format-list-bulleted"
                    :type="ligne.demandesLogistique.length > 0 ? 'is-success' : 'is-primary'"
                    :class="{ 'text-access-no-permission'
                      : !checkPermissions(permDemande.lecture) }">
                  </b-icon>
                </a>
              </b-tooltip>
            </div>
          </div>
        </div>
        <div class="column is-12" v-if="moduleDemandeImpression && !!ligne.id">
          <div class="columns is-multiline">
            <div class="column is-9 pdt-0">
              <p class="label">
                {{$t('editionCommande.logistique.demandeImpresssion')}}
              </p>
            </div>
            <div class="column is-1 pdt-0">
              <b-tooltip :label="$t('demandeLogistique.tooltip.addDemandeImpression')"
                         position="is-left">
                <a
                  @click="checkPermissions(permDemandeImpression.maj)
                    ? openDemandeImpressionPopUp() : showPopUp()"
                  :class="{'disabled': !afficherLien}">
                  <b-icon icon="plus-circle"
                          type="is-primary"
                          :class="{
                    'text-access-no-permission' : !checkPermissions(permDemandeImpression.maj) }">
                  </b-icon>
                </a>
              </b-tooltip>
            </div>
            <div class="column is-1 pdt-0">
              <b-tooltip :label="$t('demandeLogistique.tooltip.displayDemandesImpressions',
                  {nb: ligne.demandesImpressions.length})"
                         position="is-left">
                <a @click="checkPermissions(permDemandeImpression.lecture)
                    ? openListeDemandeImpressionPopUp(ligne) : showPopUp()"
                   :class="{'disabled': !afficherLien}">
                  <b-icon icon="format-list-bulleted"
                          :type="ligne.demandesImpressions.length > 0 ? 'is-success' : 'is-primary'"
                          :class="{ 'text-access-no-permission'
                      : !checkPermissions(permDemandeImpression.lecture) }">
                  </b-icon>
                </a>
              </b-tooltip>
            </div>
          </div>
        </div>
        <div class="column is-12"
          v-if="afficherLogistiqueTechnique && ligne.produit.produitFace
            && ligne.produit.produitFace.faceId">
          <div class="columns is-multiline">
            <div class="column is-9 pdt-0">
              <p class="label">
                {{$t('editionCommande.logistique.otTechnique')}}
              </p>
            </div>
            <div class="column is-1 pdt-0" v-if="visu">
              <b-tooltip :label="$t('demandeLogistique.tooltip.otTechCreate')"
                position="is-left">
                <router-link-blank
                  :to="{ name: 'm.logistique.ordre_travail-techAdd',
                    params: { patrimoineId: ligne.produit.produitFace.faceId,
                  typePatrimoine: constantes.FACE, ligneId: ligne.id }}"
                  icon="plus-circle"
                  typeIcon="is-primary">
                </router-link-blank>
              </b-tooltip>
            </div>
            <div class="column is-1 pdt-0" v-else></div>
            <div class="column is-1 pdt-0">
              <b-tooltip :label="$t('demandeLogistique.tooltip.viewOtTechnique',
                  {nb: ligne.otTechniques ? ligne.otTechniques.length : 0})"
                position="is-left">
                <router-link-blank :to="{ name: 'l.logistique.ordre_travail-tech',
                    params: { faceId: ligne.produit.produitFace.faceId }}"
                  icon="format-list-bulleted"
                  :typeIcon="ligne.otTechniques && ligne.otTechniques.length > 0
                    ? 'is-success' : 'is-primary'">
                </router-link-blank>
              </b-tooltip>
            </div>
          </div>
        </div>
        <div class="column is-12"
              v-if="(ligne.typeProduit === constantes.CATEGORIE_UNITAIRE && !!ligne.id)
                || (ligne.produit && ligne.produit.supportCommercial.categorieVente
                  === constantes.CATEGORIE_UNITAIRE)">
          <div class="columns">
            <div class="column is-9 pdt-0">
              <p class="label">
                {{$t('editionCommande.logistique.affectations')}}
              </p>
            </div>
            <div class="column is-1 pdt-0"
              v-if="ligne.produit && ligne.produit.supportCommercial.categorieVente
                === constantes.CATEGORIE_UNITAIRE">
              <b-tooltip
                :label="$t('demandeLogistique.tooltip.displayAffectationAutreCommande')"
                position="is-left">
                <a @click="checkPermissions(permAffectation.lecture)
                    ? popUpDisplayAffLogistiquesAutreCommande=true : showPopUp()"
                  :class="{'disabled': !afficherLien}">
                  <b-icon icon="list-status"
                    type="is-primary"
                    :class="{ 'text-access-no-permission'
                    : !checkPermissions(permAffectation.lecture) }">
                  </b-icon>
                </a>
              </b-tooltip>
            </div>
            <div class="column is-1 pdt-0"
              v-if="ligne.typeProduit === constantes.CATEGORIE_UNITAIRE && !!ligne.id">
              <b-tooltip :label="$t('demandeLogistique.tooltip.displayAffectation',
                  {nb: affectations.length})"
                position="is-left">
                <a @click="checkPermissions(permAffectation.lecture)
                    ? popUpDisplayAffectaion=true : showPopUp()"
                  :class="{'disabled': !afficherLien}">
                  <b-icon icon="format-list-bulleted"
                    :type="affectations.length > 0 ? 'is-success' : 'is-primary'"
                    :class="{ 'text-access-no-permission'
                    : !checkPermissions(permAffectation.lecture) }">
                  </b-icon>
                </a>
              </b-tooltip>
            </div>
          </div>
        </div>
        <div class="column is-12"
          v-if="isIdByDefaut
          && !!ligne.id
          && ligne.typeProduit === constantes.CATEGORIE_REGROUPEMENT
          && readOnly">
          <div class="columns is-multiline">
            <div class="column is-9 pdt-0">
              <p class="label">
                {{$t('editionCommande.logistique.affectationsLogistiques')}}
              </p>
            </div>
            <div class="column is-1 pdt-0">
            </div>
            <div class="column is-1 pdt-0"
              v-if='!ligne.ligneCommandeVenteInterneId'>
              <b-tooltip :label="$t('editionCommande.logistique.voirAffectation')"
                position="is-left">
                <router-link
                  :to="{ name: 'm.logistique.demande',
                    params: { idCommande: devisCommandeId,idLigneCommande: ligne.id }
                    }"
                  :class="{ 'text-access-no-permission' : !checkPermissions(permDemande.lecture) }">
                  <b-icon
                    icon="call-split"
                    type="is-primary">
                  </b-icon>
                 </router-link>
              </b-tooltip>
            </div>
            <div class="column is-1 pdt-0"
              v-else>
              <b-tooltip :label="$t('editionCommande.logistique.voirAffectation')"
                position="is-left">
                <router-link
                  :to="{ name: 'm.logistique.demande',
                    params: { idCommande: ligne.commandeVenteInterneId,
                      idLigneCommande: ligne.ligneCommandeVenteInterneId }
                    }"
                  :class="{ 'text-access-no-permission' : !checkPermissions(permDemande.lecture) }">
                  <b-icon
                    icon="call-split"
                    type="is-primary">
                  </b-icon>
                 </router-link>
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="popUpDisplayDemandeLogistique"
      class="modal"
      width="1000"
      has-modal-card>
      <demande-logistique
        :ligneCommande="ligne"
        :devisCommandeId="devisCommandeId"
        :demandeurId="commercialId || assistantId"/>
    </b-modal>
    <b-modal v-model="popUpDisplayAffectaion" has-modal-card class="modal">
      <affectation :ligneCommande="ligne" @changeAffectations="changeAffectations" />
    </b-modal>
    <b-modal v-model="popUpAddDemandeLogistique" has-modal-card class="modal">
      <creation-demande
        :lignesCommande="[ligne]"
        :devisCommandeIdFromLigne="devisCommandeId"
        :demandeurId="commercialId || assistantId"/>
    </b-modal>
    <b-modal
      v-model="popUpDisplayDemandeImpression"
      class="modal"
      has-modal-card>
      <pop-up-edition-demande-impression :ligne-commande="ligne" :commande="commande"
                                         :detailsDemandeImpression="demandeImpression"/>
    </b-modal>
    <b-modal v-model="popUpDisplayListeDemandeImpression" has-modal-card class="modal" width="1000">
      <pop-up-demande-impression :ligne-commande="ligne"/>
    </b-modal>
    <b-modal v-model="popUpDisplayAffLogistiquesAutreCommande" has-modal-card class="modal">
      <affectations-autre-commande :ligneCommande="ligne"
                                   :toutesLignesCommandesIds="toutesLignesCommandesIds"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import {
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_UNITAIRE,
  CATEGORIE_DIVERS,
  CATEGORIE_DISPOSITIF,
} from '@/configuration/catalogue/produitConf';
import formatDate from '@/services/general/formatDate';
import { GUID_VIDE } from '@/configuration/general';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { DEMANDE, AFFECTATION, DEMANDE_IMPRESSION } from '@/configuration/logistique/permissionsLogistiqueConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { FACE } from '@/configuration/gabed/emplacement/emplacementConf';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import cloneDeep from 'lodash/cloneDeep';
import popUpEditionDemandeImpression
  from '@/components/commande/logistique/p_editionDemandeImpresssion';
import popUpDemandeImpression
  from '@/components/commande/logistique/p_demandesImpressions';
import demandeLogistique from './p_demandesLogistiques';
import affectation from './p_affectation';
import creationDemande from './p_editionDemande';
import affectationsAutreCommande from './p_affectationsAutreCommande';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const TourneeFaceSemaine = createNamespacedHelpers('tourneeFaceSemaine');

export default {
  props: {
    ligne: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    visu: {
      type: Boolean,
      required: false,
      default: false,
    },
    toutesLignesCommandesIds: {
      type: Array,
      required: true,
    },
    afficherLien: {
      type: Boolean,
      required: false,
      default: true,
    },
    isDevis: {
      type: Boolean,
      required: false,
      default: false,
    },
    devisCommandeId: {
      type: String,
      required: false,
      default: '',
    },
    commercialId: {
      type: Number,
      required: false,
      default: null,
    },
    assistantId: {
      type: Number,
      required: false,
      default: null,
    },
    commande: {
      type: Object,
      required: false,
      default: null,
    },
  },
  components: {
    demandeLogistique,
    affectation,
    creationDemande,
    affectationsAutreCommande,
    routerLinkBlank,
    popUpEditionDemandeImpression,
    popUpDemandeImpression,
  },
  data() {
    return {
      constantes: {
        CATEGORIE_UNITAIRE,
        CATEGORIE_REGROUPEMENT,
        FACE,
        CATEGORIE_DIVERS,
        CATEGORIE_DISPOSITIF,
      },
      permDemande: DEMANDE,
      permAffectation: AFFECTATION,
      permDemandeImpression: DEMANDE_IMPRESSION,
      popUpDisplayDemandeLogistique: false,
      popUpDisplayAffectaion: false,
      popUpAddDemandeLogistique: false,
      popUpDisplayAffLogistiquesAutreCommande: false,
      popUpDisplayDemandeImpression: false,
      popUpDisplayListeDemandeImpression: false,
      affectations: [],
      demandeImpression: null,
      demandesImpressionsList: [],
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    ...TourneeFaceSemaine.mapGetters({
      tourneeFaceSemaine: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
    }),
    isIdByDefaut() {
      return this.ligne.id !== GUID_VIDE;
    },
    checkDateDateDebutDatePlanifiie() {
      return (this.ligne.datePlanifieeLogistiqueAffichage
        && !(moment(this.ligne.dateDebut)
          .isSame(moment(this.ligne.datePlanifieeLogistiqueAffichage))));
    },
    afficherLogistiqueTechnique() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key);
    },
    moduleDemandeImpression() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...TourneeFaceSemaine.mapActions({
      actionLoadTourneeFaceSemaine: 'loadTourneeFaceSemaine',
    }),
    formatDate(date) {
      return formatDate(date);
    },
    getPeriodeVendue(ligne) {
      if (ligne.dateDebut && ligne.dateFin) {
        const result = {
          dateDebut: formatDate(ligne.dateDebut),
          dateFin: formatDate(ligne.dateFin),
        };
        if (ligne.ligneReseau?.anneeSemaine) {
          result.semaine = this.$t('detail.article.semaine', { semaine: ligne.ligneReseau.anneeSemaine.toString().substring(4, 6) });
        }
        return result;
      }
      return this.$t('dateDevis.pasDate');
    },
    deleteLigne() {
      if (this.ligne.id) return;
      this.$emit('deleteLigne');
    },
    async getAllAffectations() {
      const data = {
        query: {
          affectationLogistiqueLigneCommandeIds: this.ligne.id ? [this.ligne.id] : [],
          estAffectee: true,
          societeId: this.societeActiveId,
          anneeSemaineBetweeen: {
            anneeSemaineDebut: getAnneeSemaineFromDate(this.ligne.dateDebut),
            anneeSemaineFin: getAnneeSemaineFromDate(this.ligne.dateFin),
          },
        },
      };
      await this.actionLoadTourneeFaceSemaine(data);
      this.affectations = cloneDeep(this.tourneeFaceSemaine);
    },
    changeAffectations(value) {
      this.affectations = value;
    },
    openDemandeImpressionPopUp() {
      this.popUpDisplayDemandeImpression = true;
    },
    openListeDemandeImpressionPopUp() {
      this.popUpDisplayListeDemandeImpression = true;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key,
        PARAMETRES_INTERNE_KEYS.demandeImpression.key,
      ]);
      if (this.ligne.typeProduit === CATEGORIE_UNITAIRE) await this.getAllAffectations();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>
